// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventEmitter } from 'events';
class SideBarButtonsHelperClass {
    constructor() {
        this.connectedStatus = false;
        this._eventEmitter = new EventEmitter();
    }
    subscribeOnConnectedStatusChanged(callback) {
        this._eventEmitter.on('OnConnectedStatusChanged', callback);
    }
    unsubscribeOnConnectedStatusChanged(callback) {
        this._eventEmitter.off('OnConnectedStatusChanged', callback);
    }
    OnConnectedStatusChangedEmit(value) {
        this.connectedStatus = value;
        this._eventEmitter.emit('OnConnectedStatusChanged', value);
    }
}
export const SideBarButtonsHelper = new SideBarButtonsHelperClass();
